var Handlebars = require("handlebars/runtime");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<em class=\"map-search-helper\">"
    + container.escapeExpression((lookupProperty(helpers,"t")||(depth0 && lookupProperty(depth0,"t"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"CIVICS.COMMON.MAP_SEARCH_HELPER_TEXT",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":1,"column":30},"end":{"line":1,"column":74}}}))
    + "</em>\n<div class=\"map-region\"></div>\n<div class=\"results-region\"></div>\n<div class=\"clearMe\"></div>\n\n";
},"useData":true});